import { useState } from 'react'
import cn from 'classnames'

import { CardSection } from '@components/CardSection'
import { CardSectionButton } from '@components/CardSectionButton'
import { QuantitySelector } from '@components/QuantitySelector'

import Button from '@components/Button'
import MessageBox, { MSG_WARNING } from '@components/MessageBox'

import { invoicePriceFormatter } from 'shared/utils'
import { useConfirm } from 'shared/hooks/useConfirm'

import styles from './styles.module.scss'

const WaitListBtn = ({ onClick }) => {
    const { confirm, ConfirmModal } = useConfirm()

    const handleClick = async () => {
        if (await confirm()) {
            onClick()
        }
    }

    return (
        <div className="d-flex justify-content-end">
            <ConfirmModal
                title="subscription.purchase.addtowaitinglist.confirm.title"
                text="subscription.purchase.addtowaitinglist.confirm.text"
            />
            <Button btnStyle="primary" onClick={handleClick}>
                <T>subscription.purchase.label.addtowaitinglist</T>
            </Button>
        </div>
    )
}

const ProductWithRatesExtra = ({ prdctExtra }) => {
    const [open, setOpen] = useState(false)

    const btnText = open ? 'productWithRates.seeLessDetails' : 'productWithRates.seeMoreDetails'

    return (
        <>
            {open && <span className="text-light text-small">{prdctExtra}</span>}
            <Button className="text-small mt-1" btnStyle="em-link" onClick={() => setOpen(!open)}>
                <T>{btnText}</T>
            </Button>
        </>
    )
}

export const ProductWithRates = ({ children, selectedRate, prd, selectRate, changeQuantity, addToWaitList }) => {
    const isRateSelected = rate => selectedRate?.rateId === rate.ratePlanId

    const isPromoRate = rate => !!rate.promoCode && rate.promoCode !== ''

    const activeSelected = selectedRate && prd.prdctCd === selectedRate.prdctCd
    const isWaitList = Boolean(prd.waitListId)

    return (
        <CardSection activeSelected={activeSelected} notActive className="px-3 py-3 mt-3">
            <div className="d-sm-flex justify-content-between align-items-start">
                <div>
                    <div className="font-weight-bold">{prd.prdctName}</div>
                    <div className="text-light text-small">{prd.prdctLongDesc}</div>
                    {prd.prdctExtra && <ProductWithRatesExtra prdctExtra={prd.prdctExtra} />}
                    {activeSelected && children}
                    {isWaitList && (
                        <MessageBox type={MSG_WARNING} className={styles.messageBox}>
                            <T>subscription.purchase.waitlist.info</T>
                        </MessageBox>
                    )}
                </div>

                <div className="d-flex flex-wrap flex-row">
                    {prd.ratePlans?.map((rate, i) => (
                        <>
                            <CardSectionButton
                                key={i}
                                onClick={() => selectRate(rate, isWaitList)}
                                value={invoicePriceFormatter(rate.price)}
                                description={rate.name}
                                isSelected={isRateSelected(rate)}
                                isSpecialValue={isRateSelected(rate) && isPromoRate(rate)}
                            />
                        </>
                    ))}
                </div>
            </div>
            {changeQuantity && (
                <QuantitySelector
                    value={(prd.prdctCd === selectedRate?.prdctCd && selectedRate?.quantity) || 1}
                    changeQuantity={v => changeQuantity(prd.prdctCd, v)}
                    disabled={prd.prdctCd !== selectedRate?.prdctCd}
                    className="justify-content-end mt-2"
                />
            )}
            {activeSelected && !isWaitList && (
                <div className={cn('row', 'justify-content-end', { 'mt-3': changeQuantity })}>
                    <div className={cn('col-12', 'col-sm-6', styles.productRateDescription)}>
                        {selectedRate.description}
                    </div>
                </div>
            )}
            {activeSelected && isWaitList && (
                <WaitListBtn onClick={() => addToWaitList(selectedRate.rateId, prd.waitListId)} />
            )}
        </CardSection>
    )
}
